import { FeatureFlagsConfig } from './lib/models';

export const featureFlagsConfig: FeatureFlagsConfig = {
  industry: {},
  industryBestWorst: {},
  industryGuidedTour: {},
  commodityRisk: {},
  showAllDisplayViews: {},
  subscriptions: {},
  uploadSites: {},
  embeddedCommodityDashboard: {},
  analyseScorecardsHideOthers: {},
  ['release:deep-dive']: {
    removeBy: new Date('2026-10-01'),
  },
  ['release:deep-dive-promo']: {},
  ['enable:deep-dive-new-badge']: {},
  ['risk-map:enable-export']: {},
  ['risk-map:enable-globe-option']: {},
  ['risk-map:drop-pin-for-score']: {},
  ['release:api-token']: {},
};
